interface City {
  name: string;
  lat: number;
  lon: number;
}

export const popularCities: City[] = [
  // Major Cities
  { name: 'תל אביב-יפו', lat: 32.0853, lon: 34.7818 },
  { name: 'ירושלים', lat: 31.7683, lon: 35.2137 },
  { name: 'חיפה', lat: 32.7940, lon: 34.9896 },
  { name: 'ראשון לציון', lat: 31.9497, lon: 34.8089 },
  { name: 'פתח תקווה', lat: 32.0889, lon: 34.8862 },
  { name: 'אשדוד', lat: 31.7892, lon: 34.6402 },
  { name: 'נתניה', lat: 32.3215, lon: 34.8532 },
  { name: 'באר שבע', lat: 31.2525, lon: 34.7915 },
  { name: 'בני ברק', lat: 32.0871, lon: 34.8382 },
  { name: 'חולון', lat: 32.0154, lon: 34.7792 },

  // North
  { name: 'צפת', lat: 32.9646, lon: 35.4960 },
  { name: 'טבריה', lat: 32.7922, lon: 35.5312 },
  { name: 'עכו', lat: 32.9281, lon: 35.0820 },
  { name: 'נהריה', lat: 33.0089, lon: 35.0981 },
  { name: 'כרמיאל', lat: 32.9146, lon: 35.2960 },
  { name: 'קריית שמונה', lat: 33.2075, lon: 35.5721 },
  { name: 'עפולה', lat: 32.6078, lon: 35.2897 },

  // Center
  { name: 'רמת גן', lat: 32.0684, lon: 34.8248 },
  { name: 'הרצליה', lat: 32.1624, lon: 34.8447 },
  { name: 'רעננה', lat: 32.1836, lon: 34.8719 },
  { name: 'כפר סבא', lat: 32.1750, lon: 34.9069 },
  { name: 'רחובות', lat: 31.8928, lon: 34.8113 },
  { name: 'לוד', lat: 31.9566, lon: 34.8989 },
  { name: 'רמלה', lat: 31.9293, lon: 34.8655 },
  { name: 'מודיעין', lat: 31.8969, lon: 35.0153 },
  { name: 'גבעתיים', lat: 32.0723, lon: 34.8120 },

  // South
  { name: 'אשקלון', lat: 31.6689, lon: 34.5715 },
  { name: 'אילת', lat: 29.5581, lon: 34.9482 },
  { name: 'דימונה', lat: 31.0689, lon: 35.0320 },
  { name: 'ערד', lat: 31.2588, lon: 35.2128 },
  { name: 'קריית גת', lat: 31.6100, lon: 34.7642 },
  { name: 'שדרות', lat: 31.5251, lon: 34.5971 },
  { name: 'אופקים', lat: 31.3130, lon: 34.6198 },

  // Sharon
  { name: 'הוד השרון', lat: 32.1590, lon: 34.8934 },
  { name: 'קריית אונו', lat: 32.0636, lon: 34.8553 },
  { name: 'יהוד', lat: 32.0331, lon: 34.8907 },
  { name: 'אור יהודה', lat: 32.0280, lon: 34.8580 },
  { name: 'ראש העין', lat: 32.0956, lon: 34.9520 },

  // Haifa Area
  { name: 'קריית ביאליק', lat: 32.8275, lon: 35.0686 },
  { name: 'קריית ים', lat: 32.8494, lon: 35.0700 },
  { name: 'קריית מוצקין', lat: 32.8384, lon: 35.0775 },
  { name: 'טירת כרמל', lat: 32.7602, lon: 34.9718 },
  { name: 'נשר', lat: 32.7631, lon: 35.0478 },

  // Jerusalem Area
  { name: 'בית שמש', lat: 31.7307, lon: 34.9893 },
  { name: 'מעלה אדומים', lat: 31.7767, lon: 35.2908 },
  { name: 'גבעת זאב', lat: 31.8615, lon: 35.1694 },

  // Dead Sea Area
  { name: 'עין בוקק', lat: 31.1989, lon: 35.3628 },
  { name: 'מצפה רמון', lat: 30.6102, lon: 34.8017 }
];

// Group cities by region for better organization
export const cityRegions = {
  'ערים מרכזיות': ['תל אביב-יפו', 'ירושלים', 'חיפה', 'ראשון לציון', 'באר שבע'],
  'צפון': ['צפת', 'טבריה', 'עכו', 'נהריה', 'כרמיאל', 'קריית שמונה', 'עפולה'],
  'מרכז': ['פתח תקווה', 'רמת גן', 'הרצליה', 'רעננה', 'כפר סבא', 'רחובות', 'מודיעין'],
  'דרום': ['אשדוד', 'אשקלון', 'אילת', 'דימונה', 'ערד', 'קריית גת', 'שדרות'],
  'שרון': ['נתניה', 'הוד השרון', 'קריית אונו', 'יהוד', 'ראש העין'],
  'אזור חיפה': ['קריית ביאליק', 'קריית ים', 'קריית מוצקין', 'טירת כרמל', 'נשר'],
  'אזור ירושלים': ['בית שמש', 'מעלה אדומים', 'גבעת זאב'],
  'ים המלח והערבה': ['עין בוקק', 'מצפה רמון']
};